module.exports = "<div class=\"shadow-border center-block\">\n  <div class=\"content\">\n    <div class=\"background\"></div>\n    <img class=\"placeholder center-block\" src=\"{{(user.image && user.image!='')?user.image:'/assets/placeholder.png'}}\">\n    <h2 class=\"text-center\">{{user.first_name + \" \" + user.last_name}}</h2>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/user-window/user-window.component.html
// module id = ../../../../../src/app/user-window/user-window.component.html
// module chunks = main